module.exports = __webpack_public_path__ + "img/ko_KR.d163dcb.jpg";